export default {
  label: {
    sentimentIndex: 'Índice de sentimento',
    engagementIndex: 'Índice de engajamento',
  },
};
